// Copyright (c) 2022 Fall Guy LLC All Rights Reserved.

import './index.css';

import pkg                                  from '../package.json';
import { FAQ }                              from './faq';
import * as hooks                           from './hooks';
import registerServiceWorker                from './util/registerServiceWorker';
import _                                    from 'lodash';
import React                                from 'react';
import ReactDOM                             from 'react-dom';
import ReactMarkdown                        from 'react-markdown';

const SERVICE_URL = process.env.NODE_ENV === 'production' ? 'https://api.brutalistitties.com/' : 'http://localhost:7175/';

//----------------------------------------------------------------//
const FormInput = ( props ) => {

    return (
        <div className = 'form-input'>
            <label>{ props.label }</label>
            <div className = 'form-input-inner'>
                <input
                    type            = 'text'
                    value           = { props.value }
                    placeholder     = { props.placeholder }
                    onChange        = { props.onChange }
                    readOnly        = { props.readOnly }
                />
                <input type = 'submit' value = { props.action } onClick = { props.onSubmit }/>
            </div>
        </div>
    );
}

//----------------------------------------------------------------//
const AgeClaimForm = ( props ) => {

    const [ challenge, setChallenge ]               = React.useState ( '' );
    const [ challengeToken, setChallengeToken ]     = React.useState ( '' );
    const [ claim, setClaim ]                       = React.useState ( '' );
    const [ busy, setBusy ]                         = React.useState ( false );

    const getChallenge = async () => {
        const response = await ( await fetch ( `${ SERVICE_URL }challenge/` )).json ();
        setChallenge ( response.challenge );
        setChallengeToken ( response.token );
    }

    React.useEffect (() => { getChallenge (); }, []);

    const onCopy = () => {
        navigator.clipboard.writeText ( challenge );
    }

    const onSubmit = async () => {
        
        if ( !claim ) return;
        setBusy ( true );

        try {
            const response = await ( await fetch (
                `${ SERVICE_URL }claim/`, {
                    method:         'POST',
                    headers:        {[ 'content-type' ]: 'application/json' },
                    body: JSON.stringify ({
                        token:      challengeToken,
                        claim:      claim,
                    })
                }
            )).json ();

            props.onAccessToken ( response.token, response.type );
        }
        catch ( error ) {
            console.log ( error );
        }

        setBusy ( false );
    }

    return (
        <div
            className = 'form-blurb'
            style = {{
                visibility: props.hide ? 'hidden' : 'visible',
            }}
        >

            <p>Want to remove the black bars? Verify your age with an <b>anonymous ad hoc age claim</b> from <a href = 'https://sure.social' target = '_blank'>SURE.social</a>.
            Nothing about this site will be revealed to SURE.social. Nothing about your SURE.social account will be revealed to this site.
            This site's server is stateless and will not record anything about your visit.
            Haven't verified your SURE.social account? Test things out with a <b>pretend</b> claim. We won't tell.</p>
 
            <FormInput
                label           = 'challenge string'
                value           = { challenge }
                onSubmit        = { onCopy }
                action          = 'copy'
                readOnly
            />

            <FormInput
                label           = 'age claim'
                value           = { claim }
                placeholder     = 'SURE.social Age Claim'
                onChange        = {( event ) => { setClaim ( event.target.value ); }}
                onSubmit        = { onSubmit }
                action          = 'submit'
            />

            <p className = 'form-instructions'><b>Instructions:</b> Go to SURE.social and sign up for a free account.
            Copy the challenge string from here and paste it into the <b>Ad Hoc</b> tab of SURE.social's <b>Identites</b> screen.
            Click 'Make Ad Hoc Claim' if you've been verified. Otherwise, click 'Pretend'. Copy the result and paste it
            in the 'age claim' field above.</p>

            <h3
                className   = 'form-faq'
                onClick     = { props.onShowFAQ }
            >
                FAQ
            </h3>
        </div>
    );
}

//----------------------------------------------------------------//
const AgeClaimMessage = ( props ) => {

    return (
        <div className = 'message'>
            <h3>{ props.message }</h3>
            <p style = {{ color: 'white', cursor: 'pointer' }} onClick = { props.onReset }>Reset</p>
        </div>
    );
}

//----------------------------------------------------------------//
const App = () => {

    hooks.useVersionedBrowserCache ( `${ SERVICE_URL }meta` );

    const [ slide, setSlide ]                       = React.useState ();
    const [ claimType, setClaimType ]               = React.useState ( 'none' );
    const [ showFAQ, setShowFAQ ]                   = React.useState ( false );
    const [ busy, setBusy ]                         = React.useState ( false );

    const getSlide = async ( slideName, token ) => {
        if ( busy ) return;
        setBusy ( true );
        const slidePath     = slideName ? `/${ slideName }` : '';
        const url           = `${ SERVICE_URL }slides${ slidePath }?token=${ token || 'none' }`;
        const slide         = await ( await fetch ( url )).json ();
        setSlide ( slide );
        setBusy ( false );
    }

    React.useEffect (() => { getSlide (); }, []);

    const onAccessToken = async ( token, type ) => {
        await getSlide ( slide.curr, token );
        setClaimType ( type );
    }

    const onReset = async ( token, type ) => {
        setSlide ( _.assign ({}, slide, { token: 'none' }));
        setClaimType ( 'none' );
    }

    return (
        <React.Fragment>
            <If condition = { showFAQ }>
                <div className = 'modal' onClick = {() => { setShowFAQ ( false ); }}>
                    <ReactMarkdown className = 'modal-content'>
                        { FAQ }
                    </ReactMarkdown>
                </div>
            </If>

            <div className = 'page'>

                <div className = 'header flex-center'>
                    <div className = 'title-group'>
                        <h1>BRUTALISTITTIES</h1>
                        <h2 className = 'sub-title'>an 18+ gallery of brutalist architecture badly photoshopped with classical titties</h2>
                    </div>
                </div>

                <div className = 'slideshow'>
                    <div className = 'slideshow-left flex-center'>
                        <button className = 'nav-button' onClick = {() => { getSlide ( slide.prev, slide.token ); }}>
                            <i className = 'material-icons'>chevron_left</i>
                        </button>
                    </div>

                    <div className = 'slideshow-center'>
                        <If condition = { slide }>
                            <div className = 'aspect-outer'>
                                <div className = 'slide-frame'>
                                    <img className = 'slide-image' src = { `${ SERVICE_URL }images/${ slide.curr }?token=${ slide.token }` }/>
                                </div>
                            </div>
                        </If>
                    </div>

                    <div className = 'slideshow-right flex-center'>
                        <button className = 'nav-button' onClick = {() => { getSlide ( slide.next, slide.token ); }}>
                            <i className = 'material-icons'>chevron_right</i>
                        </button>
                    </div>
                </div>

                <div className = 'action-area'>

                    <div className = 'form'>
                        

                        <AgeClaimForm
                            onAccessToken = { onAccessToken }
                            onShowFAQ = {() => { setShowFAQ ( true ); }}
                            hide = { claimType !== 'none' }
                        />

                        <Choose>
                            <When condition = { claimType === 'over18' }>
                                <AgeClaimMessage message = '18+ ACCESS GRANTED' onReset = { onReset }/>
                            </When>
                            <When condition = { claimType === 'pretend' }>
                                <AgeClaimMessage message = '18+ ACCESS GRANTED (PRETEND)' onReset = { onReset }/>
                            </When>
                        </Choose>
                    </div>

                    <div className = 'footer flex-center'>
                        <footer>
                            { `Copyright © 2024 by Sure Social, Inc. - v${ pkg.version }` }
                        </footer>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

//----------------------------------------------------------------//
ReactDOM.render (
    <App/>,
    document.getElementById ( 'root' )
);

// registerServiceWorker ();
